import React, { useState } from 'react';
import styles from '../css/SearchBar.module.css';
import icon from '../statics/images/cross.png';
import { photofolioActions } from '../redux/reducers/reducers';
import { useDispatch } from 'react-redux';

export const SearchBar = ({ searchedTextHandle }) => {
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const dispatch = useDispatch();

    const toggleSearch = () => {
        setIsSearchOpen(!isSearchOpen);
    };

    const searchHandle = (text) => {
        dispatch(photofolioActions.searchedTextHandle(text));
    }

    return (
        <div className={styles.searchBox}>
            <input type='text' placeholder='Search...' onChange={(e) => searchHandle(e.target.value)} />
        </div>
    );
};
